import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/user-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-5a1c1466"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "job-info-wrapper" }
const _hoisted_2 = { class: "row-data d-flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Status", -1))
const _hoisted_4 = { class: "data d-flex align-items-center" }
const _hoisted_5 = { class: "row-data d-flex" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Due Date", -1))
const _hoisted_7 = { class: "data d-flex align-items-center" }
const _hoisted_8 = {
  key: 1,
  class: "data deadline-select d-flex align-items-center"
}
const _hoisted_9 = { class: "row-data d-flex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Assignee", -1))
const _hoisted_11 = { class: "data d-flex align-items-center" }
const _hoisted_12 = {
  key: 0,
  src: _imports_0,
  alt: "user-icon",
  width: "24",
  height: "24"
}
const _hoisted_13 = { class: "row-data" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "display-inline ps-2" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#moduleAddParticipant",
  ref: "openModal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_task_status_select = _resolveComponent("task-status-select")!
  const _component_SelectDate = _resolveComponent("SelectDate")!
  const _component_DeadlineSelect = _resolveComponent("DeadlineSelect")!
  const _component_LogoAndName = _resolveComponent("LogoAndName")!
  const _component_user_selection = _resolveComponent("user-selection")!
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_VariableSelection = _resolveComponent("VariableSelection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_task_status_select, {
          status: _ctx.computedStatus,
          "onUpdate:status": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedStatus) = $event))
        }, null, 8, ["status"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_ctx.isExecution)
          ? (_openBlock(), _createBlock(_component_SelectDate, {
              key: 0,
              date: _ctx.computedDueDate,
              "onUpdate:date": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedDueDate) = $event))
            }, null, 8, ["date"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createVNode(_component_DeadlineSelect, {
                  config: _ctx.computedDueDateConfig,
                  "onUpdate:config": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedDueDateConfig) = $event))
                }, null, 8, ["config"])
              ])
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_user_selection, {
          selectedUsers: _ctx.computedAccountablePerson,
          "onUpdate:selectedUsers": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedAccountablePerson) = $event)),
          checkAgainstModule: true,
          label: "Select Accountable User",
          exactlyOne: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LogoAndName, {
              user: _ctx.computedAccountablePerson[0],
              rowView: true,
              middleAvatarSize: true
            }, null, 8, ["user"]),
            (!_ctx.computedAccountablePerson)
              ? (_openBlock(), _createElementBlock("img", _hoisted_12))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["selectedUsers"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("p", _hoisted_14, [
        _createTextVNode("References "),
        _createElementVNode("span", _hoisted_15, [
          _createVNode(_component_VariableSelection, {
            selectedVariables: _ctx.variables,
            "onUpdate:selectedVariables": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.variables) = $event)),
            label: "Selected references",
            isExecution: _ctx.isExecution
          }, {
            default: _withCtx(() => [
              _createVNode(_component_feather_icon, {
                type: "plus-circle",
                class: "position-absolute ms-4 cursor-pointer",
                stroke: "rgba(31, 50, 69, 0.5)",
                size: "24"
              })
            ]),
            _: 1
          }, 8, ["selectedVariables", "isExecution"])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variables, (variable) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "mb-2 variable",
          key: variable
        }, [
          _createTextVNode(_toDisplayString(_ctx.getVariable(variable).name) + ": ", 1),
          (_ctx.getVariable(variable).type === 'LINK')
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                _createElementVNode("i", null, [
                  _createElementVNode("a", {
                    target: "_blank",
                    href: _ctx.getVariable(variable).value
                  }, _toDisplayString(_ctx.getVariable(variable).label ||
          _ctx.getVariable(variable).value), 9, _hoisted_17)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.getVariable(variable).type !== 'LINK')
            ? (_openBlock(), _createElementBlock("i", _hoisted_18, _toDisplayString(_ctx.getVariable(variable).value), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _withDirectives(_createElementVNode("button", _hoisted_19, null, 512), [
      [_vShow, false]
    ])
  ]))
}